import Vue from "vue";

const desktopSize = 991;
const sOffset = 250;
let userScroll;

if (document.querySelector(".js-sticky-menu") !== null) {
   const app = new Vue({
      el: ".js-sticky-menu",
      data: {
         isOpen: false,
         setLevel: false,
         isDesktop: false,
         isSticky: false,
         isMobileClosed: true,
         showQuickButton: false,
         scrolled: 0,
         lastScrolled: 0,
         scrollMenuClosed: false,
         links: window.links,
      },
      mounted: function () {
         let that = this;

         if (window.innerWidth > desktopSize) {
            that.initDesktop();
         } else {
            that.initMobile();
         }

         let observer = new IntersectionObserver((entries) => {
            if (
               !entries[0].isIntersecting &&
               entries[0].boundingClientRect.top <=
                  document.querySelector(".sticky-container").offsetHeight * 2 -
                     1
            ) {
               this.isSticky = true;
            } else {
               this.isSticky = false;
            }
         });
         let stickContainer = document.querySelector(".sticky-container");
         if (stickContainer !== null) {
            observer.observe(document.querySelector(".sticky-container"));
         }
         userScroll = document.documentElement.scrollTop;

         window.onscroll = function (e) {
            let newScroll = document.documentElement.scrollTop;

            if (
               (userScroll - newScroll > sOffset &&
                  that.isOpen &&
                  !that.isDesktop &&
                  !that.scrollMenuClosed) ||
               (newScroll - userScroll > sOffset &&
                  that.isOpen &&
                  !that.isDesktop &&
                  !that.scrollMenuClosed)
            ) {
               that.close();
               that.isMobileClosed = true;
               that.showQuickButton = true;
               that.scrollMenuClosed = true;
               setTimeout(() => {
                  that.scrollMenuClosed = false;
               }, 500);
            } else if (
               (userScroll - newScroll > sOffset &&
                  that.isOpen &&
                  that.isDesktop &&
                  !that.scrollMenuClosed) ||
               (newScroll - userScroll > sOffset &&
                  that.isOpen &&
                  that.isDesktop &&
                  !that.scrollMenuClosed)
            ) {
               that.setLevel = false; // back to selection
               that.showQuickButton = false;
               that.scrollMenuClosed = true;
               that.close();
               const btns = document.querySelectorAll(
                  "button.sticky-menu__toggle"
               );
               btns.forEach((btn) => btn.classList.remove("active-button"));

               setTimeout(() => {
                  that.scrollMenuClosed = false;
               }, 500);
            }
         };
      },
      computed: {
         getTitle: function () {
            if (this.setLevel !== false && this.setLevel !== null) {
               return this.links[this.setLevel].title;
            } else {
               return null;
            }
         },
      },
      methods: {
         getLinks: function () {
            if (
               this.setLevel !== false &&
               this.setLevel !== null &&
               this.links.length > 0
            ) {
               return this.links[this.setLevel].hyperlinks;
            }
            return;
         },
         openOptions: function () {
            this.isOpen = true;
         },
         initMobile: function () {
            this.isOpen = true;
            this.setLevel = false;
            this.isDesktop = false;
            this.isMobileClosed = true;
            this.showQuickButton = false;
         },
         initDesktop: function () {
            this.isOpen = false;
            this.setLevel = false;
            this.isDesktop = true;
            this.isMobileClosed = false;
            this.showQuickButton = false;
         },
         mobileClose: function () {
            this.close();
            this.showQuickButton = true;
            this.isMobileClosed = true;
         },
         mobileOpen: function () {
            this.isMobileClosed = false;
            this.isOpen = true;
            this.isDesktop = false;
            this.setLevel = false;
            this.showQuickButton = false;
         },
         closeMenu: function () {
            this.setLevel = false;
            this.showQuickButton = false;
         },

         scrollToTargetAdjusted: function (target) {
            var element = document.getElementById(target);
            if (element == null) {
               console.error("id finnes ikke");
               return;
            }
            var firstElementChild = element.firstElementChild;

            var style =
               firstElementChild.currentStyle ||
               window.getComputedStyle(firstElementChild);
            const headerOffset =
               document.querySelector(".sticky-container").offsetHeight;
            const isStuck = this.isDesktop ? 1 : 0;
            const isMobile = !this.isDesktop ? 70 : 0;
            var elementPosition = firstElementChild.getBoundingClientRect().top;
            var offsetPosition =
               elementPosition +
               window.pageYOffset -
               parseInt(style.marginTop) * isStuck -
               headerOffset -
               isMobile;

            window.scrollTo({
               top: offsetPosition,
               behavior: "smooth",
            });
         },

         clickLink: function (el) {
            const btns = document.querySelectorAll(
               "button.sticky-menu__toggle"
            );
            btns.forEach((btn) => btn.classList.remove("active-button"));
            let target = el.target.hash.substr(1);

            if (target !== null) {
               this.scrollToTargetAdjusted(target);
            } else {
               console.error("id finnes ikke");
            }

            el.preventDefault();

            if (this.isDesktop) {
               this.setLevel = false;
               this.isOpen = false;
            } else {
               this.setLevel = false;
               this.isOpen = false;
               this.showQuickButton = true;
            }
         },
         close: function () {
            this.isMobileClosed = true;
            this.isOpen = false;
            this.setLevel = false;
            this.showQuickButton = false;
         },
         setActive: function (val, e) {
            this.setLevel = val;
            if (this.isDesktop) {
               this.isOpen = true;
               const btns = document.querySelectorAll(
                  "button.sticky-menu__toggle"
               );
               btns.forEach((btn) => btn.classList.remove("active-button"));
               e.srcElement.classList.add("active-button");
            } else {
               //this.isOpen = false;
               //document.body.classList.add("menu-is-expanded");
            }
         },
      },
   });
}
